import { Autocomplete, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneButton from '../../../../Components/OneButton/OneButton'
import { AddCircle } from '@mui/icons-material'
import { useContext, useEffect, useState } from 'react'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { WebSocketContext } from '../../../../Providers/WebSocket/WebSocketContext'

const ProcuraVisitante = ({ height }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { buscarInfoVisitante, activeCond, ativarNovoVisitante } = useContext(VisitantesContext)
    const [searchText, setSearchText] = useState('')
    const [selectedValue, setSelectedValue] = useState(null)

    const [visitantes, setVisitantes] = useState([])

    const getVisitantes = (msg) => {
        const visitantesBack = msg.data.visitantes
        setVisitantes(visitantesBack)
    }

    useEffect(() => {
        if (searchText.length > 2) {
            const inputTratado = searchText.replace(/'/g, "''")
            addRoute("buscarTodosVisitantes", getVisitantes)
            sendWs("buscarTodosVisitantes", { text: inputTratado, id_central: activeCond.id_central })
        }
    }, [searchText])

    const handleChangeInput = (event) => {
        if (event != '') {
            setSearchText(event)
        }
    }

    const handleLimpaInput = () => {
        setSearchText("")
        setSelectedValue(null)
    }

    const handleEscolheVisitante = (cdAcessoVisitante) => {
        buscarInfoVisitante(cdAcessoVisitante)
        setVisitantes([])
        setSearchText('')
    }

    return (
        <Grid sx={{
            display: 'flex',
            width: '100%',
            height,
            borderBottom: '1px solid white',
            alignItems: 'center',
            justifyContent: 'space-around',
            '@media (max-width: 1440px)': {
                height: '9%'
            }
        }}>
            <Grid>
                <Typography sx={{ color: 'black', fontWeight: '600' }}>Nome ou {activeCond.pais === 'es-CL' ? 'RUT' : 'CPF'}:</Typography>
            </Grid>
            <Grid sx={{ width: '65%' }}>
                <Autocomplete
                    options={visitantes}
                    getOptionLabel={(option) => `${option.NOME} - ${activeCond.pais === 'es-CL' ? option.rut || 'Sem RUT' : option.cpf || 'Sem CPF'}`}
                    filterOptions={(options) => options}
                    value={selectedValue}
                    noOptionsText="Digite pelo menos 3 letras ou números e aguarde"
                    // value={visitanteInfo && visitanteInfo.nome != undefined
                    //     ? { NOME: visitanteInfo.nome, cpf: visitanteInfo.cpf, CD_ACESSO: visitanteInfo.CD_ACESSO }
                    //     : null}
                    placeholder='Digite pelo menos 3 letras ou números e aguarde'
                    sx={{
                        '& input': {
                            border: 'none',
                            width: '100%',
                            // bgcolor: disabled' ? '#c9c7c7' : 'background.paper',
                            bgcolor: 'background.paper',
                            color: (theme) =>
                                theme.palette.getContrastText(theme.palette.background.paper)
                        },
                        '& fieldset': {
                            border: 'none'
                        }
                    }}
                    onChange={(event, newValue) => {
                        handleEscolheVisitante(newValue?.CD_ACESSO)
                    }}
                    onInputChange={(event, newInputValue) => {
                        handleChangeInput(newInputValue)
                    }}
                    onFocus={ handleLimpaInput }
                    renderInput={(params) => (
                        <div style={{ width: '100%' }} ref={params.InputProps.ref}>
                            <input
                                value={searchText}
                                style={{ width: '100%', height: '30px', borderRadius: '5px' }}
                                {...params.inputProps}/>
                        </div>
                    )}
                />
            </Grid>
            <OneButton
                id="button"
                backgroundColor="#0FBB00"
                variant="contained"
                IconStart={AddCircle}
                onClick={() => {
                    ativarNovoVisitante(searchText)
                }}
                sxIconStart={{ fontSize: '1.3rem' }}
            >
                <span style={{ fontSize: '0.6rem' }}>Novo Cadastro</span>
            </OneButton>
        </Grid>
    )
}

export default ProcuraVisitante
